import { Component } from '@angular/core';
import { IconComponent, SectionLinkDirective } from '../../shared';
import { GALLERY } from '../../content/home.content';

@Component({
  selector: 'app-platform-gallery',
  imports: [IconComponent, SectionLinkDirective],
  templateUrl: './platform-gallery.component.html'
})
export class PlatformGalleryComponent {
  readonly content = GALLERY;
}
